module.exports = __webpack_public_path__ + "media/motioncoany_facebook_07_sfxvoice_final.48b2f605.mp4";